/**
 * Returns `true` when Hub typography customization should be active.
 *
 * Typography is a sub-feature of advanced theming and never ships without it,
 * so this is gated by `useIsAdvancedThemingEnabled`, which ANDs together:
 *   1. The product-level flag `advanced-theming-in-hub` (via HubContext).
 *   2. The platform-level Statsig gate `hub-advanced-theming` (the v2
 *      colour palette gate).
 *
 * Cross-host safe: returns `false` when HubContext is not mounted
 * (Confluence Company Hub, CSM, etc.) because `useIsAdvancedThemingEnabled`
 * returns false in that case.
 */
import { useIsAdvancedThemingEnabled } from '../use-is-advanced-theming-enabled';

export const useIsHubTypographyEnabled = (): boolean => {
	return useIsAdvancedThemingEnabled();
};
